// import react libraries
import React, { useState } from "react";
import { usePagination, DOTS } from "./usePagination";
import { useTranslation } from "react-i18next";

const MobilePagination = (props) => {
    // translation
    const { t } = useTranslation();
    const [showPage, setShowPage] = useState(false);

    const {
        onPageChange,
        totalCount,
        perPageCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        onPageSizeChange,
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];

    const openPage = (e) => {
        setShowPage(!showPage);
    }

    return (
        <nav className="text-xs space-y-1" aria-label="Table navigation">
            <div className="text-xs font-normal text-light-400 capitalize">{ t("showing") } {currentPage === 1 ? currentPage : ((currentPage-1)*pageSize)+1} { t('to') } {((currentPage-1)*pageSize) + perPageCount} { t('of') } {totalCount} { t('entries') }</div>
            <div className="flex justify-end">
                <ul className="space-x-4 flex items-center justify-between mx-2 " >
                    <li key="prev" className={currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'} onClick={currentPage === 1 ? null : onPrevious}>
                        <div>
                            { currentPage === 1 
                                ? 
                                    <img src="../../../../assets/icons/table/left-arrow-disable.svg" alt="left-arrow-disable" />
                                : 
                                    <img src="../../../../assets/icons/table/left-arrow-active.svg" alt="left-arrow-active" />
                            }
                        </div>
                    </li>
                    <div>
                        <ul className="flex items-center justify-between space-x-1">
                            {paginationRange.map((pageNumber, index) => {
                                if (pageNumber === DOTS) {
                                    return <li className="cursor-pointer" key={`pag`+index}>&#8230;</li>;
                                }
                                return (
                                    <li key={`pag`+index} className={(pageNumber === currentPage ? 'border-blue-normal bg-blue-normal text-white' : 'border-black-100 bg-white text-light-400') +" rounded border py-1 px-2 text-center cursor-pointer"} onClick={() => onPageChange(pageNumber)}>
                                        {pageNumber}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <li key="next" className={currentPage === lastPage ? 'cursor-not-allowed' : 'cursor-pointer'} onClick={currentPage === lastPage ? null : onNext}>
                        <div>
                            { currentPage === lastPage
                                ? 
                                    <img src="../../../../assets/icons/table/right-arrow-disable.svg" alt="right-arrow-disable" />
                                : 
                                    <img src="../../../../assets/icons/table/right-arrow-active.svg" alt="right-arrow-active" />
                            }
                        </div>
                    </li>
                </ul>
                <div className="relative" onClick={(e) => openPage(e)}>
                    <button className="rounded w-14 text-light-400 border border-black-100 bg-white p-1 text-center flex justify-between items-center">
                        <span>{pageSize}</span>
                        <img src="../../../../assets/icons/table/down-arrow.svg" alt="down-arrow" />
                    </button>
                    {
                        showPage
                        ? 
                            <ul className="absolute z-10 -top-[10.7rem] right-[3px] border border-white shadow-md text-background-dark">
                                <li onClick={() => onPageSizeChange(10)} className="rounded-t text-light-400 bg-white hover:bg-black-100 py-2 px-4 block whitespace-no-wrap cursor-pointer">10</li>
                                <li onClick={() => onPageSizeChange(50)} className="rounded-t text-light-400 bg-white hover:bg-black-100 py-2 px-4 block whitespace-no-wrap cursor-pointer">50</li>
                                <li onClick={() => onPageSizeChange(100)} className="bg-white text-light-400 hover:bg-black-100 py-2 px-4 block whitespace-no-wrap cursor-pointer">100</li>
                                <li onClick={() => onPageSizeChange(250)} className="bg-white text-light-400 hover:bg-black-100 py-2 px-4 block whitespace-no-wrap cursor-pointer">250</li>
                                <li onClick={() => onPageSizeChange(500)} className="bg-white text-light-400 hover:bg-black-100 py-2 px-4 block whitespace-no-wrap cursor-pointer">500</li>
                            </ul>
                        : null
                    }
                </div>
            </div>
        </nav>
    );
};

export default MobilePagination;